import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Referee, ReferenceTypes } from '../../referencing.models';

@Component({
    selector: 'referencing-dashboard',
    templateUrl: './referencing-dashboard.component.html',
    styleUrls: ['./referencing-dashboard.component.scss'],
    standalone: false
})
export class ReferencingDashboardComponent implements OnInit {

  @Input() referees: Referee[] = [];
  @Input() userName?: string = '';
  @Input() companyName: string = '';
  @Input() role: string = '';
  @Input() clientEmail: string = '';

  @Output() refereeToAddDetailsTo = new EventEmitter<Referee>();

  public referenceTypes = Object.values(ReferenceTypes);

  public ngOnInit(): void {
    window.scrollTo(0, 0);
  }

  public openRefereeForm(referee: Referee){
    this.refereeToAddDetailsTo.emit(referee);
  }

  getTimeOfDay():string{
    let hours = (new Date()).getHours();
    if (hours < 12){
      return 'Morning';
    } else if (hours < 18){
      return 'Afternoon';
    } else {
      return 'Evening';
    }
  }
}
